export default __webpack_public_path__ + "static/testimonial-hosam-19813815300f939503a23f71e8af03b4.jpg";